import React, {useState, useEffect} from 'react'
import { Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { FormBox, Span, TextButton, TextLabel, TextValue } from "../../styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { httpsCallable } from "firebase/functions";
import { nameBoxSx } from "./styles";
import { functions } from "../../../../Infrastructure/config";
import { ShowErrorToast, ShowSuccessToast } from "../../../Common/Toast/toast";
import { useSelector } from "react-redux";
import ButtonLoading from "../../../Common/Button/ButtonLoading";
import { trackEvent } from "../../../../Infrastructure/Utilities/analytics";
import useAuthentication from "../../../../Infrastructure/States/onAuthStateChange";
import AnalyticsConstants from "../../../../Infrastructure/Constants/AnalyticsContants";
import ERROR_CONSTANTS from "../../../../Infrastructure/Constants/errorConstants";
import { USER_LOGS_CLIENT } from "../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../Infrastructure/Utilities/safeClientLogEvent";
import {
  StyledTextField,
} from "../../../../Infrastructure/Theme/styledComponents";
export const NameBox = ({
  handleOpen,
  handleClose,
  showEditName,
}) => {
  const { userId } = useAuthentication()
  const [loading, setLoading] = useState(false)
  const ip = useSelector((state) => state.ip.address)
  const userData = useSelector((state) => state.userData.data);
  const page = useSelector((state) => state.route.currentRoute);
  const first_name = userData?.account?.first_name;
  const last_name = userData?.account?.last_name;
  const styles = nameBoxSx(showEditName);
  const nameFormik = useFormik({
    initialValues: {
      firstName: first_name || "",
      lastName: last_name || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .trim()
        .required("First name is required"),
      lastName: Yup.string()
        .trim()
        .required("Last name is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        setLoading(true)
        const { firstName, lastName } = values;
        if (!nameFormik.isValid) {
          return;
        }
        const updateProfile = httpsCallable(functions, "updateaccount");
        const requestData = {
          ip,
          page,
          firstName: firstName,
          lastName: lastName
        };
        await updateProfile(requestData).then(() =>
          ShowSuccessToast("Full name updated successfully.", {position: "top-center"})
        );
      try{
          trackEvent(AnalyticsConstants.FULL_NAME_CHANGED, { user_id: userId })
      }catch(trackingError) {
        await safeClientLogEvent({
        ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
        uid: userId || null,
        source: "nameBox.jsx",
        emailInfo: null,
        metadata: null,
        error: trackingError?.message || null
      });
      }
        handleClose();
        resetForm();
      } catch (err) {
        ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST, {position: "top-center"});
        await safeClientLogEvent({
          ...USER_LOGS_CLIENT.ACCOUNT_NAME_UPDATE_FAILED,
          uid: userId || null,
          source: "nameBox.jsx",
          emailInfo: null,
          metadata: { Fullname: `${nameFormik?.values?.firstName} ${nameFormik?.values?.lastName}` } || null,
          error: err?.message || null
        });
      } finally {
        setSubmitting(false);
        setLoading(false)
      }
    },
  });
  //Effect to update nameFormik values when userData changes
  useEffect(() => {
    if (showEditName && userData?.account) {
      nameFormik.setValues({
        firstName: userData.account.first_name || "",
        lastName: userData.account.last_name || "",
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showEditName, userData]);
  return (
    <Box sx={styles.container}>
      <Stack sx={styles.headerStack} direction="row">
        <TextLabel>Full Name</TextLabel>
        <TextValue>
          {first_name?.charAt(0).toUpperCase() + first_name?.slice(1)}{" "}
          {last_name?.charAt(0).toUpperCase() + last_name?.slice(1)}
        </TextValue>
        {!showEditName ? (
          <Span
            direction="row"
            alignItems={"center"}
            onClick={() => handleOpen({ prop: "name" })}
          >
            <TextButton curser="pointer">Edit</TextButton>
            <KeyboardArrowDownIcon fontSize="small" color="primary" />
          </Span>
        ) : (
          <Span
            direction="row"
            alignItems={"center"}
            onClick={() => handleClose()}
          >
            <TextButton curser="pointer">Edit</TextButton>
            <KeyboardArrowUpIcon fontSize="small" color="primary" />
          </Span>
        )}
      </Stack>
      {showEditName && (
        <Box>
          <FormBox
            component="form"
            onSubmit={nameFormik.handleSubmit}
            noValidate
          >
            <Grid container>
              <Grid lg={5} md={12} sm={12} xs={12}>
                <Box sx={styles.fieldWrapper}>
                  <StyledTextField
                    name="firstName"
                    label={
                    nameFormik.touched.firstName &&
                      Boolean(nameFormik.errors.firstName)
                      ? nameFormik.errors.firstName
                      : "First Name"
                    }
                    variant="standard"
                    onChange={nameFormik.handleChange}
                    value={nameFormik.values.firstName}
                    error={
                      nameFormik.touched.firstName &&
                      Boolean(nameFormik.errors.firstName)
                    }
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid lg={2}></Grid>
              <Grid lg={5} md={12} sm={12} xs={12}>
                <Box sx={styles.fieldWrapper}>
                  <StyledTextField
                    name="lastName"
                    label={
                    nameFormik.touched.lastName &&
                      Boolean(nameFormik.errors.lastName)
                      ? nameFormik.errors.lastName
                      : "Last Name"
                    }
                    variant="standard"
                    onChange={nameFormik.handleChange}
                    value={nameFormik.values.lastName}
                    error={
                      nameFormik.touched.lastName &&
                      Boolean(nameFormik.errors.lastName)
                    }
                    fullWidth
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container sx={styles.actionGrid}>
              <Grid lg={2} md={2} sm={6} xs={6}>
                <Box
                  width="90%"
                  margin="0 auto"
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Button variant="contained" onClick={handleClose}>
                    Cancel
                  </Button>
                </Box>
              </Grid>
              <Grid lg={2} md={2} sm={6} xs={6}>
                <Box sx={styles.buttonBox}>
                  <ButtonLoading text={"Update"} loading={loading} type={"submit"} />
                </Box>
              </Grid>
              <Grid lg={6} md={6} sm={6} xs={6}></Grid>
            </Grid>
          </FormBox>
        </Box>
      )}
      <hr />
    </Box>
  );
};
